import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-login",
  templateUrl: "./admin-login.component.html",
  styleUrls: ["./admin-login.component.css"],
})
export class AdminLoginComponent implements OnInit {
  loginForm!: FormGroup;
  otpSend: boolean = true;
  loginAdmin: boolean = false;
  loading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: ["", Validators.required],
      password: ["", Validators.compose([Validators.required])],
    });
  }
  login() {
    if (this.loginForm.valid) {
      const loginObj = {
        username: this.loginForm.value.username,
        password: this.loginForm.value.password,
        usertype: "admin",
      };
      this.loading = true;
      this.services.adminLogin(loginObj).subscribe(
        (response: any) => {
          console.log("response", response);
          
          if (response.status == 200) {
            this.snackBar.open("Logged in successfully", "Success", {
              duration: 3000,
            });
            this.loading = false;
            localStorage.setItem("adminToken", response.body.auth);
            this.router.navigateByUrl("admin/dashboard");
          }
        },
        (error) => {
          this.loading = false;
          this.snackBar.open(error.error.message, "Fail", {
            duration: 3000,
          });
        }
      );
    }
  }
}
